export function AndroidIcon() {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 32 32"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        d="m9 7-2-3m16 3 2-3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M6 14a10 10 0 0 1 20 0H6Zm0 2h20v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-9Z" />
      <path
        d="M3 17v7m26-7v7M11 26v4m10-4v4"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="11" cy="10" r="1" fill="#242b25" />
      <circle cx="21" cy="10" r="1" fill="#242b25" />
    </svg>
  );
}

export function AppleIcon() {
  return (
    <svg
      width="27"
      height="29"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M17.05 12.04c.03 3.29 2.89 4.39 2.92 4.4-.02.08-.46 1.57-1.51 3.11-.91 1.33-1.85 2.66-3.34 2.69-1.46.03-1.93-.87-3.6-.87-1.66 0-2.18.84-3.56.9-1.43.05-2.52-1.44-3.44-2.77-1.87-2.72-3.3-7.68-1.38-11.03.95-1.66 2.65-2.71 4.49-2.74 1.4-.03 2.72.95 3.57.95.85 0 2.44-1.17 4.11-1  .7.03 2.67.28 3.94 2.14-.1.06-2.35 1.37-2.33 4.22ZM14.3 3.86c.76-.92 1.27-2.2 1.13-3.48-1.09.04-2.41.73-3.19 1.65-.7.82-1.32 2.13-1.15 3.39 1.21.09 2.45-.62 3.21-1.56Z" />
    </svg>
  );
}
